export default "__VITE_ASSET__3692f101__"